var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.903,
    height: 13.154,
    viewBox: "0 0 7.903 13.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3225",
    "data-name": "Group 3225",
    transform: "translate(-88.048 -710.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8495_-_Outline",
    "data-name": "Path 8495 - Outline",
    d: "M4.152,10.73a.8.8,0,0,1-.8-.8V9.186A3.326,3.326,0,0,1,5.221,6.247a2.354,2.354,0,0,0,1.228-2.61A2.353,2.353,0,0,0,1.8,4.152a.8.8,0,0,1-1.6,0A3.953,3.953,0,1,1,7.694,5.9,3.985,3.985,0,0,1,5.95,7.671a1.736,1.736,0,0,0-1,1.514V9.93A.8.8,0,0,1,4.152,10.73Z",
    transform: "translate(87.848 710.223)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_167",
    "data-name": "Line 167",
    d: "M0,1.325a.8.8,0,0,1-.8-.8V0A.8.8,0,0,1,0-.8.8.8,0,0,1,.8,0V.525A.8.8,0,0,1,0,1.325Z",
    transform: "translate(91.998 722.253)",
    fill: "#16161a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.f61a793ea532aa9ab738037dd83a4002.svg";
export { ForwardRef as ReactComponent };